export enum LOAN_REASON {
  HOUSE_BILLS = 'HOUSE_BILLS',
  RENOVATION_OR_REPAIRS = 'RENOVATION_OR_REPAIRS',
  TRAVEL = 'TRAVEL',
  DEBT = 'DEBT',
  MEDICAL_EXPENSES = 'MEDICAL_EXPENSES',
  EDUCATION = 'EDUCATION',
  SHOPPING = 'SHOPPING',
  OTHERS = 'OTHERS',
}
